import React, { useState } from "react";
import { Box, Divider, Switch, Button, Flex, Text } from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { LogoUpload } from "@components/Asset";
import { MilestoneForm } from "./";

const MilestoneItem = ({ info, id, onSuccess }) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  if (!info) return null;

  function onClose() {
    setOpen(false);
    onSuccess();
  }

  return (
    <div>
      <Box mb="lg">
        <Flex justify="center">
          <LogoUpload
            url={info.filename_url}
            onSuccess={() => onSuccess()}
            milestoneId={id}
          />
        </Flex>
        <Text align="center" mt="xs" size="xs">
          {t("mixer:milestone:asset_size_recommendation")}
        </Text>
      </Box>
      <MilestoneForm
        title={info.title}
        description={info.description}
        value={info.value}
        multipleAward={info.multiple_award}
        requiresPickup={info.requires_pickup}
        startAt={info.start_at_for_form}
        endAt={info.end_at_for_form}
        variety={info.variety}
        onSuccess={onClose}
        id={id}
      />
      <Divider mt="lg" mb="lg" />
      <MilestoneStatus id={id} onSuccess={onClose} value={info.status} />
      {info.can_delete && (
        <>
          <Divider mt="lg" mb="lg" />
          <MilestoneDelete id={id} onSuccess={onClose} />
        </>
      )}
    </div>
  );
};

export default MilestoneItem;

const MilestoneStatus = ({ value, onSuccess, id }) => {
  const { t } = useTranslation();
  function onChange() {
    axios
      .post(`/milestones/toggle-status/`, { milestone_id: id })
      .then(() => onSuccess())
      .catch((err) => {
        toast.error(err);
      });
  }

  return (
    <div>
      <Flex gap="xs">
        <Button
          onClick={onChange}
          size="xs"
          color="green"
          variant={value === 1 ? "filled" : "light"}
        >
          {t("common:active")}
        </Button>
        <Button
          onClick={onChange}
          size="xs"
          color="red"
          variant={value === 2 ? "filled" : "light"}
        >
          {t("common:inactive")}
        </Button>
      </Flex>
    </div>
  );
};

const MilestoneDelete = ({ onSuccess, id }) => {
  const { t } = useTranslation();
  function onClick() {
    axios
      .delete(`/milestones/${id}/`)
      .then(() => onSuccess())
      .catch((err) => {
        toast.error(err);
      });
  }

  return (
    <div>
      <Flex gap="xs" justify="center">
        <Button onClick={onClick} size="xs" color="gray" variant="subtle">
          {t("common:delete")}
        </Button>
      </Flex>
    </div>
  );
};
